export function getSessionTokenCookieName (env: string) {
	return env === "production" ? "ideamapSessionToken" : `${env}IdeamapSessionToken`;
}

export function getSessionUserIdCookieName (env: string) {
	return env === "production" ? "ideamapSessionUser" : `${env}IdeamapSessionUser`;
}
